import {Provider } from 'react-redux';
import { store } from './store/store';
import { AppRouter } from './routers/AppRouter';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

import '@wojtekmaj/react-datetimerange-picker/dist/DateTimeRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';

export const MotoclickApp = () => {
    return (
        <Provider store={store}>
            <AppRouter/>
        </Provider>
    )
}
